import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
import { ref, reactive, watch, onMounted, onUnmounted } from 'vue';
import useClipboard from 'vue-clipboard3';
export default /*#__PURE__*/_defineComponent({
  props: {
    type: {
      type: String,
      default: 'info',
      validator: function validator(val) {
        return val === 'error' || val === 'warning' || val === 'success' || val === 'info';
      }
    },
    message: {
      type: String,
      default: '',
      require: true
    },
    traceId: {
      type: String
    },
    duration: {
      type: Number,
      default: 6000
    },
    canCopy: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;

    var _useClipboard = useClipboard(),
        toClipboard = _useClipboard.toClipboard;

    var classes = ref(['dt-message', {
      'dt-message-error': props.type === 'error'
    }, {
      'dt-message-warning': props.type === 'warning'
    }, {
      'dt-message-success': props.type === 'success'
    }, {
      'dt-message-info': props.type === 'info'
    }]);
    var visible = ref(true);
    var closed = ref(false);
    var PopoverVisible = ref(true);
    var outerWebFlag = ref(window.AppConfig.outerWebFlag);
    var onClose = reactive();
    var timer = ref(null);
    watch(closed, function (newVal) {
      if (newVal) {
        visible.value = false;
      }
    }); // methods

    var close = function close() {
      closed.value = true;

      if (typeof onClose === 'function') {
        onClose();
      }
    };

    var startTimer = function startTimer() {
      timer.value = setTimeout(function () {
        if (!closed.value) {
          close();
        }
      }, props.duration);
    };

    var keydown = function keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!closed.value) {
          close();
        }
      }
    }; // 复制报错信息


    var copyErrorMessage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                msg = "traceId: ".concat(props.traceId, ";\n errorMessage: ").concat(props.message, ";\n url: ").concat(window.location.href);
                _context.prev = 1;
                _context.next = 4;
                return toClipboard(msg);

              case 4:
                res = _context.sent;
                PopoverVisible.value = true;
                console.log('复制成功', res);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log('复制失败', _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function copyErrorMessage() {
        return _ref.apply(this, arguments);
      };
    }();

    var contactXiaomi = function contactXiaomi() {
      copyErrorMessage();
    };

    var popoverShow = function popoverShow() {
      setTimeout(function () {
        PopoverVisible.value = false;
      }, 2000);
    };

    var clearTimer = function clearTimer() {
      clearTimeout(timer.value);
    };

    onMounted(function () {
      startTimer(); // 暂时注释，方便调试

      visible.value = true;
      document.addEventListener('keydown', keydown);
    });
    onUnmounted(function () {
      clearTimer();
      document.removeEventListener('keydown', keydown);
    });
    return function (_ctx, _cache) {
      var _component_el_popover = _resolveComponent("el-popover");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex-m-between", classes.value]),
        onMouseenter: clearTimer,
        onMouseleave: startTimer
      }, [_createElementVNode("p", null, _toDisplayString(__props.message), 1), _createElementVNode("div", null, [_createVNode(_component_el_popover, {
        modelValue: PopoverVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return PopoverVisible.value = $event;
        }),
        placement: "top",
        content: "复制成功",
        onShow: popoverShow
      }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("i", {
        class: "iconfont iconic_content_copy mr15",
        onClick: copyErrorMessage
      }, null, 512), [[_vShow, (__props.type === 'warning' || __props.type === 'error') && __props.canCopy]]), outerWebFlag.value ? _withDirectives((_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "iconfont iconlianxidengtaxiaomi mr15",
        target: "_blank",
        href: "wxwork://message?username=灯塔小秘",
        onClick: contactXiaomi
      }, null, 512)), [[_vShow, (__props.type === 'warning' || __props.type === 'error') && __props.canCopy]]) : _createCommentVNode("", true), _createElementVNode("i", {
        class: "iconfont iconclose-line",
        onClick: close
      })])], 34)), [[_vShow, visible.value]]);
    };
  }
});